import { render, staticRenderFns } from "./TabSelect.html?vue&type=template&id=db276ee8&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./TabSelect.scss?vue&type=style&index=0&id=db276ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db276ee8",
  null
  
)

export default component.exports